import { defineNuxtPlugin } from '#app'
import { initializeApp, type FirebaseOptions } from 'firebase/app';
import { getPerformance, trace  } from 'firebase/performance';
import { getAnalytics, logEvent, setUserId } from "firebase/analytics";
import type { Firebase } from "@ca.vmedia.tv/domains";
declare module '#app' {
    interface NuxtApp {
        $fire: Firebase;
    }
}

const firebaseConfig: FirebaseOptions = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
};

export default defineNuxtPlugin((nuxtApp) => {
    const app = initializeApp(firebaseConfig);
    const performance = getPerformance(app);
    const analytics = getAnalytics();

    nuxtApp.provide('fire', {
        performance,
        trace,
        analytics,
        logEvent,
        setUserId
    });
});
